import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void
    }
  }
}

export default function FeedbackPowerfulPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Send message to React Native WebView that onboarding is complete
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'ONBOARDING_COMPLETE',
        }),
      )
      return
    }

    // Continue with normal form submission
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="🙌"
      heading={t('pages.onboarding.feedbackPowerful.heading')}
      text={t('pages.onboarding.feedbackPowerful.text')}
      onSubmit={handleSubmit}
    />
  )
}
